<template>
  <!-- <el-dialog
    :visible.sync="visible"
    width="1200px"
    :show-close="false"
    top="10vh"
    append-to-body
  >
    <div class="main__container">
      <img
        class="close"
        src="./img/delete.png"
        alt=""
        @click.stop="handlerClose"
      />
      <div class="left-back" @click="handleBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
      <div>
        <ArchivesCard :detail="archivesDetail" :sn="id"></ArchivesCard>
      </div>
    </div>
  </el-dialog> -->
  <DialogArchives :sn="id" :show.sync="visible">
    <ArchivesCard
      :detail="archivesDetail"
      ref="ArchivesCardRef"
      :sn="id"
    ></ArchivesCard>
  </DialogArchives>
</template>
<script>
import ArchivesCard from "./ArchivesCard.vue";
import DialogArchives from "../common/DialogArchives.vue";
export default {
  data() {
    return {
      archivesDetail: {
        archive: {
          sn: null,
        },
      },
    };
  },
  props: {
    show: Boolean,
    id: [Number, String],
  },
  components: {
    ArchivesCard,
    DialogArchives,
  },
  watch: {
    id: {
      handler(n) {
        if (n) {
          this.getArchivesDetail();
        }
      },
      immediate: true,
    },
    show(n, o) {
      // if (!n) {
      //   this.$refs["ArchivesCardRef"].echartDispose();
      // }
    },
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        return this.$emit("update:show", n);
      },
    },
  },
  methods: {
    handleBack() {
      this.$emit("back");
      this.visible = false;
    },
    handlerClose() {
      this.visible = false;
    },
    getArchivesDetail() {
      this.$axios
        .get(`/statisticsService/mechanism/survey/user?sn=${this.id}`)
        .then((resp) => {
          this.archivesDetail = resp.data;
          this.$nextTick(() => {
            this.$refs["ArchivesCardRef"].initReduceChart();
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.main__container {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
}
.wrapper1,
.wrapper2,
.wrapper3 {
  position: relative;
}
.wrapper1 {
  width: 25%;
  height: 620px;
}
.wrapper2 {
  width: 50%;
  height: 620px;
}
.wrapper3 {
  width: 50%;
}
.left-back {
  display: flex;
  align-items: center;
  position: absolute;
  left: 60px;
  top: 30px;
  z-index: 11111;
  cursor: pointer;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
}
.close {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 30px;
  top: 30px;
  z-index: 11111;
  cursor: pointer;
}
.bg-img {
  position: absolute;
  height: 100%;
  width: 100%;
}
.content {
  position: relative;
  z-index: 2;
  color: #fff;
  padding-top: 6%;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 50px;
  font-weight: bold;
  font-size: 20px;
  width: 100%;
}
.list__container {
  margin-top: 30px;
  height: 370px;
  overflow: scroll;
  .item {
    width: 100%;
    height: 39px;
    background: linear-gradient(90deg, #161f4e 0%, rgba(4, 24, 40, 0.28) 100%);
    //   opacity: 0.28;

    font-size: 16px;
    color: #01b3e6;
    font-weight: 500;
  }
  .item:hover {
    color: #fff;
    background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
  }
  .active {
    color: #fff;
    background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
  }
}
.table-name {
  color: #abd1e7;
}
::v-deep {
  .el-dialog {
    // 取消阴影和背景色
    background: rgba(0, 0, 0, 0);

    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);

    box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
  }
  .el-input__inner {
    height: 42px;
    border: 1px solid #077fd4;
    border-radius: 8px;
    background: none;
    color: #01b3e6;
  }
  .el-dialog__headerbtn {
    top: 78px;
    right: 100px;
    z-index: 122;
    font-size: 30px;
    color: #fff;
    font-size: bold;
  }
  .el-table,
  .el-table__body {
    background: transparent !important;
    color: #fff;
  }
  .el-table th {
    background-color: transparent !important;
  }
  .el-table tr {
    background-color: transparent !important;
  }
  .el-table__body tr.hover-row > td {
    background-color: #a5ccf2 !important;
  }
  .el-table tbody tr:hover > td {
    background-color: #17468d !important //修改成自己想要的颜色即可
;
  }
}
</style>
